import { render, staticRenderFns } from "./AbkEventQuickInfo.vue?vue&type=template&id=5cfba8e6&scoped=true&"
import script from "./AbkEventQuickInfo.vue?vue&type=script&lang=js&"
export * from "./AbkEventQuickInfo.vue?vue&type=script&lang=js&"
import style0 from "./AbkEventQuickInfo.vue?vue&type=style&index=0&id=5cfba8e6&scoped=true&lang=scss&"
import style1 from "./AbkEventQuickInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfba8e6",
  null
  
)

export default component.exports